export default __webpack_public_path__ + "static/media/przelewy24.f2be310f.svg";